<template>
  <div class="row align-items-center">
    <div class="col-xs-12 col-md-4">
      <b-card
        class="text-center gs-card"
        style="height: 380px"
      >
        <b-img
          :src="customize"
          height="200"
          class="p-4"
          top
        />
        <b-card-title>Website anpassen</b-card-title>

        <b-card-text>Passen Sie die Website nach Ihren Wünschen an.</b-card-text>
        <b-button
          to="/edit"
          variant="primary"
        >Website anpassen</b-button>
      </b-card>
    </div>

    <!-- <div
      class="col-4"
      v-if="$store.getters['auth/hasStripe']"
    >
      <b-card
        class="text-center gs-card"
        style="height: 380px"
      >
        <b-img
          :src="preview"
          height="200"
          class="p-4"
          top
        />
        <b-card-title>Ihr Paket</b-card-title>

        <b-card-text>Standard Paket für 9,99€ pro Monat.</b-card-text>
        <b-button
          @click="showPaymentModal = true"
          variant="primary"
        >Add-Ons buchen</b-button>
      </b-card>
    </div> -->

    <div class="col-xs-12 col-md-4">
      <b-card
        class="text-center gs-card"
        style="height: 380px"
      >
        <b-img
          :src="preview"
          height="200"
          class="p-4"
          top
        />
        <b-card-title>Website anschauen</b-card-title>

        <b-card-text>Vorschau der Website mit Ihren Fahrzeugen.</b-card-text>
        <b-button
          :href="previewUrl"
          target="_blank"
          variant="primary"
        >Website anschauen</b-button>
      </b-card>
    </div>
    <div
      class="col-xs-12 col-md-4"
      v-if="!$store.getters['auth/hasStripe']"
    >
      <b-card
        class="text-center highlight-card gs-card"
        style="height: 400px"
      >
        <b-img
          :src="buy"
          height="200"
          class="p-4"
          top
        />
        <b-card-title>Website buchen</b-card-title>

        <b-card-text>Jetzt buchen und alle Funktionen nutzen für nur 14,99€ monatlich</b-card-text>
        <b-button
          @click="showPaymentModal = true"
          style="background-color: #ef8115"
        >Jetzt starten!</b-button>
      </b-card>
    </div>
    <payment-modal
      v-model="showPaymentModal"
      v-if="showPaymentModal"
    />
  </div>
</template>


<script>
import PaymentModal from '@/components/PaymentModal.vue';

import preview from '@/assets/preview.png';
import customize from '@/assets/customize.png';
import buy from '@/assets/buy.png';


export default {
  name: 'GettingStarted',
  components: {
    PaymentModal,
  },

  data: () => ({
    preview,
    customize,
    buy,
    showPaymentModal: false,
  }),

  computed: {
    previewUrl () {
      return `${process.env.VUE_APP_WEBSITE_URL}/${this.$store.state.auth.currentUser.domain}`;
    },
  },
}
</script>

<style scoped>
.highlight-card {
  border-color: rgba(38, 143, 255, 0.5);
  /*  box-shadow: 0 0 0 0.2rem rgba(38,143,255,.5); */
}
</style>